<template>
  <section>
    <section class="w100 mt100 bg-just" :style="{ backgroundImage: 'url(/static/img/news/news.jpg)',height: '600px' }">

    </section>
    <section class="w100">
      <section class="m-w" style="margin-top: 120px;">
        <ul class="news-list">
          <li class="news-item flex-between pb110 ml60" v-for="(item,$index) in news" :key="$index">
            <div class="day-info">
              <div class="font30 c9">{{item.day}}</div>
              <div class="font18 c9">{{item.month}}</div>
            </div>
            <div class="news-info text-left mr120 ml36">
              <span class="mb20 font45">{{item.title}}</span>
              <p class="mb20 font20 c9">
                <span>{{item.author}}</span>
                <span>{{item.time}}</span>
              </p>
              <div class="content font22 c6 mb60">{{item.content}}</div>
              <img :src="item.img"/>
            </div>
          </li>
        </ul>
      </section>
    </section>
    <InnerFooter/>
    <Footer/>
  </section>
</template>

<script>
  import InnerFooter from '@/components/InnerFooter'
  import Footer from '@/components/Footer'
  import m_date from 'datetime-format'

  export default {
    components: {InnerFooter, Footer},
    data () {
      return {
        news: []
      }
    },
    mounted () {
      this.axios.get('/static/news/news.json', {})
        .then(res => {
          console.log(res.data)
          res.data.news.forEach((value, index, array) => {
            var time = m_date(value.time)
            value.day = time.format('d')
            value.month = time.format('M')
          })
          this.news = res.data.news
        })
    }
  }
</script>

<style lang="scss" scoped>

  ul {
    padding: 0;
  }

  .pb110 {
    padding-bottom: 110px;
  }

  .news-item {
    position: relative;
    border-left: 1px dashed #999999;

    &:first-child {
      line-height: 25px;
    }

    &::before {
      content: '';
      position: absolute;
      left: -12px;
      top: 0px;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background-color: #ff9999;
    }

    &::after {
      content: '';
      position: absolute;
      left: -6px;
      top: 7px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #FF0C0C;
    }

    .day-info {
      position: absolute;
      left: -60px;
      top: 0;
    }

    .content {
      line-height: 36px;
    }

    .news-info {
      padding-left: 30px;
      height: inherit;

      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/News/index.vue